import * as S from "./styles";
import { Skeleton } from "components/Skeleton";

export function AllMapDetailsSkeleton() {
  return (
    <S.Wrapper className={"skeletonWrapper"}>
      <S.Body>
        <S.OccurrenceColumn>
          <S.OccurrenceHeader>
            <S.HeaderBody>
              <S.HeaderBodyInfo>
                <S.IconContainer>
                  <Skeleton />
                </S.IconContainer>
                <S.TextContainer>
                  <h4>
                    <Skeleton width="10em" />
                  </h4>
                  <h4>
                    <Skeleton style={{ marginTop: 5 }} />
                  </h4>
                </S.TextContainer>
              </S.HeaderBodyInfo>

              <Skeleton width="34px" height="34px" />
            </S.HeaderBody>
          </S.OccurrenceHeader>
        </S.OccurrenceColumn>
        <S.Column>
          <S.OccurrenceHeader>
            <S.HeaderBody>
              <S.HeaderBodyInfo>
                <S.IconContainer>
                  <Skeleton />
                </S.IconContainer>
                <S.TextContainer>
                  <h4>
                    <Skeleton width="10em" />
                  </h4>
                  <h4>
                    <Skeleton style={{ marginTop: 5 }} />
                  </h4>
                </S.TextContainer>
              </S.HeaderBodyInfo>
              <Skeleton width="34px" height="34px" />
            </S.HeaderBody>
          </S.OccurrenceHeader>
        </S.Column>
      </S.Body>
      <div>
        <Skeleton style={{ marginRight: 10 }} height="37px" />
        <Skeleton style={{ marginRight: 10 }} height="37px" />
      </div>
    </S.Wrapper>
  );
}
